<div class="row">
  <p-dialog
    position="top"
    [closable]="false"
    [(visible)]="isSuccess"
    [breakpoints]="{ '960px': '358px' }"
    [style]="{ width: '526px', heigth: '240px' }"
    [draggable]="false"
    [modal]="true"
    [resizable]="false"
    styleClass="custom-dialog"
  >
    <!-- Success state -->
    <div *ngIf="isSuccess" class="success-content">
      <div class="content-wrapper">
        <div class="icon-container">
          <img src="assets/images/icon/svg/verify.svg" alt="Success" class="status-icon" />
        </div>
        <div class="text-content">
          <h3>{{ '::Confirm:Delivered:Email:Success' | abpLocalization }}</h3>
          <p>
            {{ '::Confirm:Delivered:Email:Success:Message' | abpLocalization }}
          </p>
        </div>
      </div>
    </div>
  </p-dialog>
</div>

<div class="row">
  <p-dialog
    position="top"
    [closable]="false"
    [(visible)]="!isSuccess"
    [breakpoints]="{ '960px': '358px' }"
    [style]="{ width: '526px', heigth: '240px' }"
    [draggable]="false"
    [modal]="true"
    [resizable]="false"
    styleClass="custom-dialog"
  >
    <div *ngIf="!isSuccess && errorMessage" class="error-content">
      <div class="content-wrapper">
        <div class="icon-container">
          <img src="assets/images/icon/svg/warning.svg" alt="Lỗi" class="status-icon" />
        </div>
        <div class="text-content">
          <h3>{{ '::Confirm:Delivered:Email:Error' | abpLocalization }}</h3>
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
